module.exports = __webpack_public_path__ + "static/media/no_image_bisnis.7a84fafb.png";